export default {
  brandColor1: '#4CAF50',
  complimentaryColor1: '#fff',
  brandColor2: '#D9222C',
  complimentaryColor2: '#fff',
};
